// extracted by mini-css-extract-plugin
export default {"main":"AlertBox_main__RSfF4"};